import FetchApiError from "@/lib/openapi/api-error";
import {
  ExtractFetchParams,
  ExtractMutationOptions,
  ExtractResponse,
  useMutationRequest,
} from "@/lib/openapi/hooks";
import { useQueryClient } from "@tanstack/react-query";

export type PostNextSwitchResponse = ExtractResponse<
  "telegramAuthorization",
  "/users/switch/next",
  "post"
>;

export type PostNextSwitchFetchParams = ExtractFetchParams<
  "telegramAuthorization",
  "/users/switch/next",
  "post"
>;

export const usePostNextSwitchMutate = ({
  queryOptions,
}: {
  queryOptions?: ExtractMutationOptions<
    PostNextSwitchResponse,
    FetchApiError,
    PostNextSwitchFetchParams,
    unknown
  >;
} = {}) => {
  const queryClient = useQueryClient();
  return useMutationRequest("telegramAuthorization", "/users/switch/next", {
    method: "post",
    queryOptions: {
      onSuccess: async (...args) => {
        await queryClient.invalidateQueries();
        queryOptions?.onSuccess?.(...args);
      },
    },
  });
};

export default usePostNextSwitchMutate;
